
export interface BinaryStorageUploadOptions {
  dispositionType: BinaryStorageContentDispositionType
  filenameAlias?: string
}

export const BinaryStorageContentDispositionType = {
  Inline: 0,
  Attachment: 1,
  Default: 0
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type BinaryStorageContentDispositionType = typeof BinaryStorageContentDispositionType[keyof typeof BinaryStorageContentDispositionType]
